/* Galerie du Nuage — fiche produit, collections, recherche (suite de gdn.js) */
(function () {
  'use strict';
  var U = window.GDNU; if (!U) return;
  var R = U.R, $ = U.$, $$ = U.$$, esc = U.esc, money = U.money, ic = U.ic, withWidth = U.withWidth, toast = U.toast, layer = U.layer;
  var setCount = U.setCount, getCart = U.getCart, openCart = U.openCart, closeCart = U.closeCart, changeLine = U.changeLine, addToCart = U.addToCart;

  /* ---------- Fiche produit ---------- */
  var PD = null, S = null;
  var dataEl = $('#pdp-data');
  if (dataEl) {
    try { PD = JSON.parse(dataEl.textContent); } catch (e) { PD = null; }
  }
  var vInput = $('[data-variant-input]'), qInput = $('[data-qty-input]');
  function hexFor(c) { var h = '#D8C8AE'; (PD.colors || []).forEach(function (x) { if (x.n === c) h = x.h; }); return h; }
  function idxFor(c) { var l = PD.ph && PD.ph[c]; if (l && l.length) return l; return PD.media.map(function (m, i) { return i; }); }
  function setImg(frame, m, hex) {
    if (!frame || !m) return;
    frame.style.setProperty('--hex', hex);
    var img = frame.querySelector('img:not(.alt)');
    if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = m.s; img.alt = m.a; }
    else frame.insertAdjacentHTML('beforeend', '<img src="' + esc(m.s) + '" alt="' + esc(m.a) + '">');
  }
  function renderGallery() {
    var list = idxFor(S.v.c), hex = hexFor(S.v.c), n = list.length;
    var g = $('#pdp-gallery'); if (!g) return;
    g.innerHTML = list.map(function (mi, i) {
      var m = PD.media[mi]; if (!m) return '';
      var badges = i === 0 && PD.badges && PD.badges.length ? '<div class="badges">' + PD.badges.slice(0, 3).map(function (b) { return '<span class="badge' + (b === 'Livré compressé' ? ' badge-dark' : '') + '">' + esc(b) + '</span>'; }).join('') + '</div>' : '';
      return '<button type="button" data-action="lb-open" data-i="' + i + '" aria-label="Agrandir la photo ' + (i + 1) + '"' + (!S.all && i >= 6 ? ' hidden' : '') + '><div class="frame" style="--hex:' + hex + '"><img src="' + esc(m.s) + '" alt="' + esc(m.a) + '" loading="' + (i < 2 ? 'eager' : 'lazy') + '">' + badges + '<span class="zoom">' + ic('zoom', 18) + '</span></div></button>';
    }).join('');
    var more = $('#gal-more');
    if (more) more.innerHTML = n > 6 ? '<button type="button" class="btn btn-ghost" data-action="more-photos" aria-expanded="' + S.all + '">' + (S.all ? 'Voir moins de photos' : 'Voir les ' + n + ' photos') + '</button>' : '';
    setImg($('#desc-img .frame'), PD.media[list[1] != null ? list[1] : list[0]], hex);
    setImg($('#sticky-buy .frame'), PD.media[list[0]], hex);
  }
  function updateVariant(v) {
    S.v = v; S.all = false;
    if (vInput) vInput.value = v.id;
    $$('[data-price]').forEach(function (el) { el.textContent = money(v.p); });
    $$('[data-p3]').forEach(function (el) { el.textContent = '3 × ' + money(Math.round(v.p / 3)); });
    $$('[data-p4]').forEach(function (el) { el.textContent = '4 × ' + money(Math.round(v.p / 4)); });
    $$('[data-color-name]').forEach(function (el) { el.textContent = v.c; });
    $$('.swatch[data-variant]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-variant')) === v.id)); });
    $$('[data-atc], [data-action="buy-now"], #pdp [data-action="add"]').forEach(function (b) { b.disabled = !v.a; });
    var lbl = $('[data-atc-label]'); if (lbl) lbl.textContent = v.a ? 'Ajouter au panier' : 'Indisponible';
    var av = $('[data-avail]'); if (av) av.innerHTML = v.a ? '<i aria-hidden="true"></i>Disponible à la commande · expédition suivie' : 'Ce coloris est indisponible pour le moment';
    if (!PD.single && window.history && history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    renderGallery();
  }
  var lb = $('#lightbox');
  function renderLb() {
    var list = idxFor(S.v.c), n = list.length; if (!n || !lb) return;
    S.lb = ((S.lb % n) + n) % n;
    var m = PD.media[list[S.lb]];
    lb.innerHTML = '<div class="lb" role="dialog" aria-modal="true" aria-label="Photos de ' + esc(PD.name) + '" data-action="lb-bg"><div class="frame" style="--hex:' + hexFor(S.v.c) + '"><img src="' + esc(m.z) + '" alt="' + esc(m.a) + '"></div>' +
      '<button type="button" class="x" data-action="lb-close" aria-label="Fermer">' + ic('close', 20, 2) + '</button>' +
      (n > 1 ? '<button type="button" class="lb-nav lb-prev" data-action="lb-step" data-d="-1" aria-label="Photo précédente">' + ic('chevL', 22, 2) + '</button><button type="button" class="lb-nav lb-next" data-action="lb-step" data-d="1" aria-label="Photo suivante">' + ic('chev', 22, 2) + '</button>' : '') +
      '<span class="lb-count">' + (S.lb + 1) + ' / ' + n + '</span></div>';
    lb.hidden = false;
  }
  function addCurrent(then) { return addToCart(S.v.id, S.qty, { _nom: PD.name }, then); }
  if (PD && vInput) {
    var cur = Number(vInput.value);
    S = { v: PD.variants.filter(function (x) { return x.id === cur; })[0] || PD.variants[0], qty: 1, all: false, lb: 0 };
    var form = $('#pdp-form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addCurrent(); });
    var atc = $('#atc-main'), bar = $('#sticky-buy');
    if (atc && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e = en[0]; var past = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('show', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true'); }).observe(atc);
    }
  }

  /* Schéma des dimensions */
  $$('.svgbox[data-dims]').forEach(function (box) {
    var L = box.getAttribute('data-dims').split(',').map(Number);
    var W = L[0], D = L[1], H = L[2] || 0, Hd = H || 80;
    if (!W || !D) return;
    var num = function (v) { return String(v).replace('.', ','); };
    var sc = Math.min(330 / W, 170 / D, 170 / Hd);
    var x0 = 80, yb = 230, w = W * sc, h = Hd * sc, dd = D * sc, armW = Math.max(10, w * 0.08), x1 = x0 + w + 80;
    var r = function (v) { return Math.round(v * 10) / 10; };
    var feet = 'M' + r(x0 + armW * 0.7) + ' ' + r(yb - h * 0.12) + 'V' + yb + 'M' + r(x0 + w - armW * 0.7) + ' ' + r(yb - h * 0.12) + 'V' + yb + 'M' + r(x1 + 8) + ' ' + r(yb - h * 0.12) + 'V' + yb + 'M' + r(x1 + dd - 8) + ' ' + r(yb - h * 0.12) + 'V' + yb;
    var lines = 'M' + x0 + ' ' + (yb + 24) + 'H' + r(x0 + w) + 'M' + x0 + ' ' + (yb + 17) + 'V' + (yb + 31) + 'M' + r(x0 + w) + ' ' + (yb + 17) + 'V' + (yb + 31) + 'M' + r(x1) + ' ' + (yb + 24) + 'H' + r(x1 + dd) + 'M' + r(x1) + ' ' + (yb + 17) + 'V' + (yb + 31) + 'M' + r(x1 + dd) + ' ' + (yb + 17) + 'V' + (yb + 31);
    if (H) lines += 'M' + (x0 - 22) + ' ' + r(yb - h) + 'V' + yb + 'M' + (x0 - 29) + ' ' + r(yb - h) + 'H' + (x0 - 15) + 'M' + (x0 - 29) + ' ' + yb + 'H' + (x0 - 15);
    box.innerHTML = '<svg viewBox="0 0 680 290" role="img" aria-label="Schéma des dimensions de ' + esc(box.getAttribute('data-name')) + ' : ' + esc(box.getAttribute('data-d')) + ' cm">' +
      '<text x="' + x0 + '" y="28" font-size="13" font-weight="700" fill="#5B625D" letter-spacing="1.5">VUE DE FACE</text>' +
      '<text x="' + r(x1) + '" y="28" font-size="13" font-weight="700" fill="#5B625D" letter-spacing="1.5">VUE DE CÔTÉ</text>' +
      '<g fill="#E4E8E1" stroke="#23392F" stroke-width="2" stroke-linejoin="round">' +
      '<rect x="' + r(x0 + armW * 0.6) + '" y="' + r(yb - h) + '" width="' + r(w - armW * 1.2) + '" height="' + r(h * 0.62) + '" rx="10"/>' +
      '<rect x="' + r(x0 + armW * 0.6) + '" y="' + r(yb - h * 0.5) + '" width="' + r(w - armW * 1.2) + '" height="' + r(h * 0.38) + '" rx="8"/>' +
      '<rect x="' + x0 + '" y="' + r(yb - h * 0.66) + '" width="' + r(armW) + '" height="' + r(h * 0.56) + '" rx="8"/>' +
      '<rect x="' + r(x0 + w - armW) + '" y="' + r(yb - h * 0.66) + '" width="' + r(armW) + '" height="' + r(h * 0.56) + '" rx="8"/>' +
      '<rect x="' + r(x1) + '" y="' + r(yb - h) + '" width="' + r(Math.max(12, dd * 0.24)) + '" height="' + r(h * 0.88) + '" rx="8"/>' +
      '<rect x="' + r(x1) + '" y="' + r(yb - h * 0.5) + '" width="' + r(dd) + '" height="' + r(h * 0.38) + '" rx="8"/></g>' +
      '<path d="' + feet + '" stroke="#23392F" stroke-width="2.4" stroke-linecap="round" fill="none"/>' +
      '<path d="' + lines + '" stroke="#8A5F2A" stroke-width="1.4" fill="none"/>' +
      '<g font-size="15" font-weight="600" fill="#1C211E">' +
      '<text x="' + r(x0 + w / 2) + '" y="' + (yb + 50) + '" text-anchor="middle">' + num(W) + ' cm</text>' +
      '<text x="' + r(x1 + dd / 2) + '" y="' + (yb + 50) + '" text-anchor="middle">' + num(D) + ' cm</text>' +
      (H ? '<text x="' + (x0 - 32) + '" y="' + r(yb - h / 2 + 5) + '" text-anchor="end">' + num(H) + ' cm</text>' : '') +
      '</g></svg>';
  });

  /* ---------- Collections : filtres et tri ---------- */
  var grid = $('#col-cards');
  var COL = { mat: 'tous', places: 'toutes', sort: 'pertinence' };
  var cards = grid ? $$('[data-card]', grid) : [];
  cards.forEach(function (c, i) { c.setAttribute('data-i', i); });
  var helpTile = grid ? $('[data-help]', grid) : null;
  function applyCol() {
    if (!grid) return;
    var list = cards.filter(function (c) {
      var m = c.getAttribute('data-m'), pl = c.getAttribute('data-pl') || '';
      if (COL.mat !== 'tous' && m !== COL.mat) return false;
      if (COL.places === '2' && pl !== '2') return false;
      if (COL.places === '3' && (!pl || pl === '2')) return false;
      return true;
    });
    var num = function (c, k) { return Number(c.getAttribute(k)); };
    if (COL.sort === 'asc') list.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
    else if (COL.sort === 'desc') list.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
    else list.sort(function (a, b) { return num(a, 'data-i') - num(b, 'data-i'); });
    cards.forEach(function (c) { c.hidden = true; });
    list.forEach(function (c) { c.hidden = false; grid.appendChild(c); });
    if (helpTile) { helpTile.hidden = !list.length; if (list.length) list[Math.min(6, list.length) - 1].insertAdjacentElement('afterend', helpTile); }
    var empty = $('#col-empty'); if (empty) empty.hidden = !!list.length;
    var shown = $('#shown'); if (shown) shown.textContent = list.length === cards.length ? list.length + ' modèles' : list.length + ' sur ' + cards.length + ' modèles';
    $$('[data-action="col-mat"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === COL.mat)); });
    $$('[data-action="col-places"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === COL.places)); });
  }

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) { if (!e.target.closest('.search')) { var qr = $('#q-results'); if (qr) qr.hidden = true; } return; }
    var a = t.getAttribute('data-action');
    if (a === 'acc') { var open = t.getAttribute('aria-expanded') === 'true'; t.setAttribute('aria-expanded', String(!open)); if (t.nextElementSibling) t.nextElementSibling.hidden = open; }
    else if (a === 'home-tab') {
      var tab = t.getAttribute('data-tab');
      $$('[data-action="home-tab"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
      $$('.home-group').forEach(function (g) { g.hidden = g.getAttribute('data-group') !== tab; });
    }
    else if (a === 'col-mat') { COL.mat = t.getAttribute('data-v'); applyCol(); }
    else if (a === 'col-places') { COL.places = t.getAttribute('data-v'); applyCol(); }
    else if (a === 'col-reset') { COL.mat = 'tous'; COL.places = 'toutes'; applyCol(); }
    else if (a === 'cart-open') { e.preventDefault(); openCart(); }
    else if (a === 'cart-close') { e.preventDefault(); closeCart(); }
    else if (a === 'cart-qty') { changeLine(t.getAttribute('data-key'), Number(t.getAttribute('data-q'))); }
    else if (S && a === 'color') {
      var id = Number(t.getAttribute('data-variant'));
      var v = PD.variants.filter(function (x) { return x.id === id; })[0];
      if (v && v.id !== S.v.id) updateVariant(v);
    }
    else if (S && a === 'qty') { S.qty = Math.min(9, Math.max(1, S.qty + Number(t.getAttribute('data-d')))); var q = $('#qty'); if (q) q.textContent = S.qty; if (qInput) qInput.value = S.qty; }
    else if (S && a === 'add') { addCurrent(); }
    else if (S && a === 'buy-now') { addCurrent(function () { location.href = '/checkout'; }); }
    else if (S && a === 'more-photos') { S.all = !S.all; renderGallery(); }
    else if (S && a === 'lb-open') { S.lb = Number(t.getAttribute('data-i')); renderLb(); }
    else if (S && a === 'lb-step') { S.lb += Number(t.getAttribute('data-d')); renderLb(); }
    else if (a === 'lb-close' || (a === 'lb-bg' && e.target === t)) { if (lb) lb.hidden = true; }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-action="col-sort"]')) { COL.sort = e.target.value; applyCol(); }
  });
  document.addEventListener('keydown', function (e) {
    if (lb && !lb.hidden && S) {
      if (e.key === 'Escape') lb.hidden = true;
      if (e.key === 'ArrowRight') { S.lb++; renderLb(); }
      if (e.key === 'ArrowLeft') { S.lb--; renderLb(); }
      return;
    }
    if (e.key === 'Escape') { if (layer && !layer.hidden) closeCart(); var qr = $('#q-results'); if (qr) qr.hidden = true; }
  });

  /* ---------- Recherche instantanée ---------- */
  var qIn = $('#q'), qRes = $('#q-results'), qT = null;
  if (qIn && qRes && R.predictive) {
    qIn.addEventListener('input', function () {
      clearTimeout(qT);
      var q = qIn.value.trim();
      if (q.length < 2) { qRes.hidden = true; return; }
      qT = setTimeout(function () {
        var url = R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,body';
        fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          qRes.innerHTML = ps.length
            ? ps.map(function (p) {
                var price = parseFloat(p.price_min || p.price || 0) * 100;
                return '<a href="' + esc(p.url) + '">' + (p.image ? '<img class="ph-img" src="' + esc(withWidth(p.image, 120)) + '" alt="" loading="lazy">' : '<span class="ph-img"></span>') + '<span class="sr-txt"><strong>' + esc(p.title) + '</strong><span class="small muted">' + money(price) + '</span></span></a>';
              }).join('') + '<a class="search-all" href="' + esc(R.search) + '?type=product&q=' + encodeURIComponent(q) + '">Voir tous les résultats</a>'
            : '<div class="search-empty">Aucun canapé ne correspond à « ' + esc(q) + ' ».</div>';
          qRes.hidden = false;
        }).catch(function () {});
      }, 180);
    });
  }

  /* Compteur du panier à jour au chargement (retour arrière du navigateur) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(function (c) { setCount(c.item_count); }).catch(function () {}); });
})();